import React, { useEffect, useState } from 'react';

import icons from './../../icons.svg';
import { InfoBanner } from '../common/utils';
import ScaleHybridCabinetPlanogram from './planograms/scaleHybridCabinetPlanogram';
import CabinetPlanogram from './planograms/cabinetPlanogram';
import PlanogramImage from './planograms/planogramImage';
import { history } from '../../store';

const Planogram = ({
  products,
  t,
  cabinet,
  slotSelected,
  cabinetActions,
  planogramConfig,
  cabinetSetting,
  replenishPlan,
  refillSchema,
}) => {
  const [planogramData, setPlanogramData] = useState({
    shelvesCount: 0,
    shelves: [],
    imageUrl: null,
  });

  const [allProducts, setAllProducts] = useState([]);
  const { deviceSubTypeName } = cabinet;

  useEffect(() => {
    if (planogramConfig.fetching) return;
    if (replenishPlan.fetching) return;
    if (refillSchema.fetching) return;

    let config = {};

    if (deviceSubTypeName === 'scale' || deviceSubTypeName === 'hybrid') {
      config = planogramConfig.data || {};
    } else {
      //if there is a planogram in refillplan for rfid cabinet, get the config from the plan
      //if not in the planogram, look into the schema
      if (replenishPlan.planogram && 'shelves' in replenishPlan.planogram) {
        config = {
          shelvesCount: replenishPlan.planogram.shelvesCount || 0,
          shelves: replenishPlan.planogram.shelves || [],
          imageUrl:
            replenishPlan.planogramImageUrl || refillSchema.planogramImageUrl,
        };
      } else if (planogramConfig.data && 'shelves' in planogramConfig.data) {
        config = {
          shelvesCount: planogramConfig.data.shelvesCount || 0,
          shelves: planogramConfig.data.shelves || [],
          imageUrl: refillSchema.planogramImageUrl,
        };
      }
    }

    if (!('shelves' in config)) {
      // if there is no planogram, try fetching shelf config from the settings for scale and hubrid cabinet
      if (deviceSubTypeName === 'scale' || deviceSubTypeName === 'hybrid') {
        const shelfConfig = cabinetSetting.shelfConfigId;

        if (shelfConfig && Object.entries(cabinet.cabinetShelfConfig).length) {
          const shelfData =
            cabinet.cabinetShelfConfig[shelfConfig]?.shelfConfig;
          setPlanogramData({
            shelves: shelfData || [],
            shelvesCount: (shelfData || []).length,
            imageUrl: null,
          });
        }
      }
    } else {
      setPlanogramData({
        shelvesCount: config.shelvesCount || 0,
        shelves: config.shelves || [],
        imageUrl: config.imageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planogramConfig, replenishPlan, refillSchema]);

  useEffect(() => {
    if (products.isFetching) return;
    const prods = products.products || [];
    setAllProducts(prods);
  }, [products]);

  const showCalibrationButton = () => {
    const { deviceSubTypeName, replenishment, calibration } = cabinet;

    if (deviceSubTypeName === 'rfid') return false;

    if (replenishment === 'on' || calibration === 'on') return false;

    if (deviceSubTypeName === 'scale' || deviceSubTypeName === 'hybrid')
      return true;

    return false;
  };

  //if there is no planogram defined, show the message
  if (!planogramData.shelvesCount) {
    return (
      <div style={{ marginTop: '20px' }}>
        <InfoBanner message={t('common:planogramMissing')} />
      </div>
    );
  }

  //for scale based/hybrid cabinet, render different planogram
  //since the slot and shelves data needs to be handled and rendered differently
  {
    if (deviceSubTypeName === 'scale' || deviceSubTypeName === 'hybrid') {
      return (
        <div className="planogram__view">
          {showCalibrationButton() && (
            <div
              className="calibration__start"
              onClick={() => {
                cabinetActions.startCalibration(
                  cabinet.deviceCode,
                  cabinet.deviceSubType,
                  'scale1'
                );
                history.push('/calibrate');
              }}
            >
              <svg>
                <use xlinkHref={`${icons}#icon-balance-scale`} />
              </svg>
              {t('common:start_calibration')}
              <svg>
                <use xlinkHref={`${icons}#icon-arrow-right`} />
              </svg>
            </div>
          )}
          <ScaleHybridCabinetPlanogram
            cabinetActions={cabinetActions}
            planogramData={planogramData}
            cabinet={cabinet}
            t={t}
            allProducts={allProducts}
            slotSelected={slotSelected}
          />
          {planogramData.imageUrl && (
            <PlanogramImage t={t} imageUrl={planogramData.imageUrl} />
          )}
        </div>
      );
    }
  }

  //planogram for RFID cabinet
  return (
    <div className="planogram__view">
      <CabinetPlanogram
        planogramData={planogramData}
        cabinet={cabinet}
        allProducts={allProducts}
        t={t}
      />
      {planogramData.imageUrl && (
        <PlanogramImage t={t} imageUrl={planogramData.imageUrl} />
      )}
    </div>
  );
};

export default Planogram;
